import { useMutation, useQuery } from '@tanstack/react-query';

import { InsuranceAssetType } from '@entities/investments';
import { ErrorResponse } from '@shared/api';

import { goldLivePrice, goldOrder, goldPreorder } from './api';
import {
  TGoldLastPriceResponse,
  TGoldOrderRequest,
  TGoldPreorderRequest,
  TGoldPreorderResponse,
} from './type';

export const useGetGoldLivePrice = () => {
  return useQuery<TGoldLastPriceResponse>({
    queryKey: ['live-price'],
    queryFn: () => goldLivePrice(InsuranceAssetType.Gold),
  });
};

export const useGoldPreOrder = () =>
  useMutation<TGoldPreorderResponse, ErrorResponse, TGoldPreorderRequest>({
    mutationFn: (data: TGoldPreorderRequest) => goldPreorder(data),
  });

export const useGoldOrder = () =>
  useMutation<string, ErrorResponse, TGoldOrderRequest>({
    mutationFn: (data: TGoldOrderRequest) => goldOrder(data),
  });
